<ng-container *ngIf="{
  status: statusPsc100$ | async,
  deviceId: _deviceId$ | async,
  properties: selectedPsc100Properties$ | async
} as resolver">
  <app-generic-device-dashboard
    [title]="labels.title"
    [uiFramework]="uiFramework"
    [status]="resolver.status"
    [deviceId]="resolver.deviceId"
    [deviceTypeLabel]="'PSC100' | titlecase"
    [deviceImageSrc]="productImageSrc"
    [defaultImageSrc]="'blocks-assets/images/productImages/inverters/ZH0019.svg'"
    [properties]="resolver.properties">
  </app-generic-device-dashboard>

  <lib-block-title
    id="psc100-devices-title"
    [title]="labels.devicesTitle">
  </lib-block-title>

  <azzurro-table
    tableId="psc100-inverters-table"
    mode="client"
    [data$]="pcsInverters$"
    [columns]="pcsInvertersColumns"
    [showRowExpansionIcon]="false"
    [allowRowClickExpansion]="false">
  </azzurro-table>
</ng-container>

<ng-template
  #psc100ActionsTemplate
  let-row>
  <mat-icon
    class="pointer"
    (click)="onDeviceSelected.emit(row.sn)">
    remove_red_eye
  </mat-icon>
</ng-template>
